<template>
  <div class="tracking-map">
    <google-map
      ref="googleMap"
      @ready="googleMapReady"
    ></google-map>
  </div>
</template>

<script>
import { find } from 'lodash'

import GoogleMap from './Google'

export default {
  name: 'tracking-map',
  props: {
    vehicles: {
      type: Array,
      default: function () {
        return []
      }
    },
    focus: String
  },
  data: function () {
    return {
      mapIsReady: false
    }
  },
  watch: {
    vehicles: function () {
      this.updateMapVehicles()
    },
    focus: function (focus) {
      const vehicle = find(this.vehicles, { _id: focus })
      if (vehicle && vehicle.position) {
        this.$refs.googleMap.animateMarker(vehicle._id)
        this.$refs.googleMap.panTo(vehicle.position)
      }
    }
  },
  components: {
    'google-map': GoogleMap
  },
  methods: {
    googleMapReady: function () {
      this.mapIsReady = true
      this.updateMapVehicles()
    },
    updateMapVehicles: function () {
      if (!this.mapIsReady) {
        return false
      }
      const googleMap = this.$refs.googleMap
      googleMap.removeMarkers()
      for (const vehicle of this.vehicles) {
        if (!vehicle.position) continue
        const marker = googleMap.createMarker({
          markerOptions: {
            position: vehicle.position,
            title: vehicle.plate,
            id: vehicle._id
          }
        })
        googleMap.setGeometryToMap(marker)
      }
      if (this.focus) googleMap.animateMarker(this.focus)
    }
  }
}
</script>

<style scoped>
.google-map {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Maps/Tracking.vue